import React, { Component } from 'react'
import { adminLogin } from '../../../redux/actions/adminActions'
import { Form, Input } from 'antd';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

export class AdminLogin extends Component {
  constructor(props){
    super(props);
    this.state={
      email: '',
      password: '',
    }
  }

  handleChange=(e)=>{
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleSubmit=()=>{
    this.props.adminLogin(this.state, this.props.history)
  }

  componentDidMount=()=>{
    // if(localStorage.jwtToken){
    //   this.props.decodeToken(localStorage.jwtToken, this.props.history)
    // }
  }


  render() {
    return (
      <div className="admin-login">
        <div className="admin-login-form">
          <img src={require('../../../assets/img/bonanza-logo.png')} alt=""/>  
          <Form>
            <Form.Item>
              <Input onChange={this.handleChange} name="email" placeholder="Email" />
            </Form.Item>
            <Form.Item>
              <Input.Password onChange={this.handleChange} name="password" placeholder="Wachtwoord" />
            </Form.Item>
          </Form>
          <button onClick={this.handleSubmit} className="med-main-btn">Inloggen</button>
          <hr/>
          <p>Mocht u problemen ondervinden met uw account, neem dan contact op met support@bestel.sr</p>
        </div>        
      </div>
    )
  }
}

export default connect(null, { adminLogin })(withRouter(AdminLogin))
